export enum PlatformType {
    APPLE = 'apple',
    FACEBOOK = 'facebook',
    GOOGLE = 'google',
    HUAWEI = 'huawei',
}